import { render, staticRenderFns } from "./berthInvestmentManage.vue?vue&type=template&id=96be1136&scoped=true&"
import script from "./berthInvestmentManage.vue?vue&type=script&lang=js&"
export * from "./berthInvestmentManage.vue?vue&type=script&lang=js&"
import style0 from "./berthInvestmentManage.vue?vue&type=style&index=0&id=96be1136&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96be1136",
  null
  
)

export default component.exports